import { rentalSourceApi } from "api/rentalSource";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedAutoAddCard } from "views/settings-integration/integrations/shared/FeedAutoAddCard";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const RentalSourceView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectRentalSource, isPending: isDisconnecting } =
    useMutation({
      mutationKey: ["RENTAL_SOURCE", "DELETE"],
      mutationFn: () => rentalSourceApi.disconnect(),
      onSuccess: () => {
        toast.success("Rental Source integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.RENTAL_SOURCE}
          name="Rental Source"
          path="/settings/integration/rental-source"
          onDisconnect={() => disconnectRentalSource()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        <FeedAutoAddCard feed="rental_source" feedLabel="Rental Source" />
        <FeedListingsCard feed="rental_source" feedLabel="Rental Source" />
      </div>
    </Layout>
  );
};
